import Amplify, { API } from 'aws-amplify';
import awsconfig from '../aws-exports';
import * as queries from './queries';
import * as mutations from './mutations';

Amplify.configure(awsconfig);

// const AUTH_MODE = {
// 	COGNITO: 'AMAZON_COGNITO_USER_POOLS',
// 	IAM: 'AWS_IAM',
// };
// let _authMode = AUTH_MODE.IAM;
// const setAuthMode = (authMode) => {
// 	_authMode = authMode;
// };

const _runQuery = async (query, parameters = undefined) => {
  const results = await API.graphql({
    query: query,
    variables: parameters,
  });
  return results;
};

const _runMutation = async (query, parameters = undefined) => {
  const results = await API.graphql({
    query: query,
    variables: { input: parameters },
  });
  return results;
};

// Fan Queries and Mutations
const createAFan = async (details) => {
  const data = await _runMutation(mutations.createFan, details);
  // @ts-ignore
  const parsedData = data?.data?.createFan;
  return parsedData;
};

const getFanData = async (cognitoId: string) => {
  const data = await _runQuery(queries.getFan, { cognitoId: cognitoId });
  // @ts-ignore
  const parsedData = data?.data?.getFan;
  return parsedData;
};

const updateFanData = async (details) => {
  const data = await _runMutation(mutations.updateFan, details);
  // @ts-ignore
  const parsedData = data?.data?.updateFan;
  return parsedData;
};

// Artist Queries and Mutations
const createAnArtist = async (details) => {
  const data = await _runMutation(mutations.createArtist, details);
  // @ts-ignore
  const parsedData = data?.data?.createArtist;
  return parsedData;
};

const getArtistData = async (cognitoId: string) => {
  const data = await _runQuery(queries.getArtist, { cognitoId: cognitoId });
  // @ts-ignore
  const parsedData = data?.data?.getArtist;
  return parsedData;
};

const updateArtistData = async (details) => {
  const data = await _runMutation(mutations.updateArtist, details);
  // @ts-ignore
  const parsedData = data?.data?.updateArtist;
  return parsedData;
};

// Genres query
const getGenres = async () => {
  const data = await _runQuery(queries.listGenres);
  // @ts-ignore
  const parsedData = data?.data?.listGenres;
  return parsedData;
};

const getSuperGenreFromGenre = async (genre) => {
  const data = await _runQuery(queries.listGenres, {
    filter: { genre: { eq: genre } },
  });
  const parsedData = data?.data?.listGenres;
  return parsedData;
};

const getSuperGenres = async () => {
  const data = await _runQuery(queries.listGenres, {
    filter: { isSuperGenre: { eq: 1 } },
  });
  // @ts-ignore
  const parsedData = data?.data?.listGenres;
  return parsedData;
};

const getSongsByGenre = async (genreInput) => {
  const data = await _runQuery(queries.listGenres, {
    filter: { superGenre: { eq: genreInput } },
  });
  let allSessions = [];
  // @ts-ignore
  const parsedData = data?.data?.listGenres.items;

  for (let genreItem of parsedData) {
    const sessions = await Promise.all(
      genreItem.sessions.items.map(async (item) => {
        return await getASessionGenre(item.id);
      }),
    );
    allSessions.push(...sessions);
  }
  allSessions = allSessions.filter((x) => x);
  return allSessions;
};

//FanGenre Queries and Mutations
const createAFanGenre = async (details) => {
  const data = await _runMutation(mutations.createFanGenre, details);
  // @ts-ignore
  const parsedData = data?.data?.createFanGenre;
  return parsedData;
};

const deleteAFanGenre = async (details) => {
  const data = await _runMutation(mutations.deleteFanGenre, details);
  // @ts-ignore
  const parsedData = data?.data?.deleteFanGenre;
  return parsedData;
};

//ArtistGenre Queries and Mutations
const createAnArtistGenre = async (details) => {
  const data = await _runMutation(mutations.createArtistGenre, details);
  // @ts-ignore
  const parsedData = data?.data?.createArtistGenre;
  return parsedData;
};

const deleteAnArtistGenre = async (details) => {
  const data = await _runMutation(mutations.deleteArtistGenre, details);
  // @ts-ignore
  const parsedData = data?.data?.deleteArtistGenre;
  return parsedData;
};

//SessionGenre Queries and Mutations
const createASessionGenre = async (details) => {
  const data = await _runMutation(mutations.createSessionGenre, details);
  // @ts-ignore
  const parsedData = data?.data?.createSessionGenre;
  return parsedData;
};

const deleteASessionGenre = async (details) => {
  const data = await _runMutation(mutations.deleteSessionGenre, details);
  // @ts-ignore
  const parsedData = data?.data?.deleteSessionGenre;
  return parsedData;
};

const getASessionGenre = async (sessionGenreId: string) => {
  const data = await _runQuery(queries.getSessionGenre, {
    id: sessionGenreId,
  });
  // @ts-ignore
  const parsedData = data?.data?.getSessionGenre.session;
  return parsedData;
};

// Session Queries and Mutations
const createASession = async (details) => {
  const data = await _runMutation(mutations.createSession, details);
  // @ts-ignore
  const parsedData = data?.data?.createSession;
  return parsedData;
};

const getASession = async (session) => {
  const data = await _runQuery(queries.getSession, { id: session });
  // @ts-ignore
  const parsedData = data?.data?.getSession;
  return parsedData;
};

const getASessionBySpotifyUri = async (trackId) => {
  const uri = 'spotify:track:' + trackId;
  // @ts-ignore
  const rawSessionData = await _runQuery(queries.sessionSpotifyUri, {
    spotifyUri: uri,
    filter: { isActive: { eq: 1 } },
  });
  //@ts-ignore
  const sessionData = rawSessionData?.data?.sessionSpotifyUri?.items[0];
  return sessionData;
};

const getListOfSessionsByArtist = async (artist) => {
  const data = await _runQuery(queries.sessionsByArtist, { artistId: artist });
  // @ts-ignore
  const parsedData = data?.data?.sessionsByArtist;
  return parsedData;
};

const updateSessionActive = async (sessId, active) => {
  const data = await _runMutation(mutations.updateSession, {
    id: sessId,
    isActive: active,
  });
  const parsedData = data?.data?.updateSession;
  return parsedData;
};

const updateSessionPlayCount = async (sessId, playCount) => {
  const data = await _runMutation(mutations.updateSession, {
    id: sessId,
    playCount,
  });
  const parsedData = data?.data?.updateSession;
  return parsedData;
};

const updateSessionSpotifyId = async (trackId, sessionId) => {
  const newSpotifyUri = trackId;
  const updateOptions = {
    id: sessionId,
    spotifyUri: newSpotifyUri,
  };
  const data = await _runMutation(mutations.updateSession, updateOptions);
  const parsedData = data?.data?.updateSession;
  return parsedData;
};

// Feedback queries and mutations
const leaveFeedback = async ({ comment, fanId, sessionId }) => {
  const feedbackDetails = {
    fanId,
    sessionId,
    comment,
  };
  const data = await _runMutation(mutations.createFeedback, feedbackDetails);
  // @ts-ignore
  const parsedData = data?.data?.createFeedback;
  return parsedData;
};

const getFeedbackByFanAndSession = async ({ sessionId, fanId }) => {
  //@ts-ignore
  const results = await _runQuery(queries.feedbackByFan, {
    fanId,
    sessionId: { eq: sessionId },
  });
  // @ts-ignore
  const parsedData = results?.data?.feedbackByFan?.items[0];
  return parsedData;
};

const getFeedbackBySession = async (details) => {
  //@ts-ignore
  const data = await _runQuery(queries.feedbackBySessionAndDate, {
    sortDirection: 'DESC',
    sessionId: details.sessionId,
  });
  // @ts-ignore
  const parsedData = data?.data?.feedbackBySessionAndDate;

  return parsedData;
};

// Likes queries and mutations
const likeASong = async ({ fanId, likeValue, sessionId }) => {
  const likeOptions = {
    fanId,
    sessionId,
    likeValue,
  };
  // @ts-ignore
  const data = await _runMutation(mutations.createTbLike, likeOptions);
  // @ts-ignore
  const parsedData = data?.data?.createTbLike;
  return parsedData;
};

const updateALike = async (details) => {
  await _runMutation(mutations.updateTbLike, {
    id: details.likeId,
    likeValue: details.likeValue,
  });
};

// TODO: Update this to accept a sessionId it will shrink this function
const listLikes = async (details) => {
  const uri = 'spotify:track:' + details.sessionId;
  // @ts-ignore
  const rawSessionData = await _runQuery(queries.sessionSpotifyUri, {
    spotifyUri: uri,
    filter: { isActive: { eq: 1 } },
  });
  //@ts-ignore
  const sessionData = rawSessionData?.data?.sessionSpotifyUri?.items[0];
  // @ts-ignore
  const rawLikesData = await _runQuery(queries.listTbLikes, {
    filter: {
      sessionId: { eq: sessionData.id },
      fanId: { eq: details.fanId },
    },
  });
  // @ts-ignore
  const parsedData = rawLikesData?.data?.listTbLikes;
  return parsedData;
};

const getLikesBySession = async (details) => {
  const data = await _runQuery(queries.likesBySession, {
    sessionId: details.sessionId,
  });

  const parsedData = data?.data?.likesBySession;
  return parsedData;
};

// Follows queries and mutations
const followAnArtist = async (details) => {
  const data = await _runMutation(mutations.createTbFollows, details);
  // @ts-ignore
  const parsedData = data?.data?.createTbFollows;
  return parsedData;
};

const getFollowsByArtist = async (artist) => {
  const data = await _runQuery(queries.followsByArtist, {
    artistId: artist,
  });
  // @ts-ignore
  const parsedData = data?.data?.followsByArtist;
  return parsedData;
};

const totalFollowsByArtist = async (artist) => {
  const data = await getFollowsByArtist(artist);
  return data.items.length;
};

export default {
  createAFan,
  getFanData,
  updateFanData,
  createAnArtist,
  getArtistData,
  updateArtistData,
  getGenres,
  getSuperGenreFromGenre,
  getSuperGenres,
  getSongsByGenre,
  createAFanGenre,
  deleteAFanGenre,
  createAnArtistGenre,
  deleteAnArtistGenre,
  createASessionGenre,
  deleteASessionGenre,
  getASessionGenre,
  createASession,
  getASession,
  getASessionBySpotifyUri,
  getListOfSessionsByArtist,
  updateSessionActive,
  updateSessionPlayCount,
  updateSessionSpotifyId,
  leaveFeedback,
  getFeedbackByFanAndSession,
  getFeedbackBySession,
  likeASong,
  updateALike,
  listLikes,
  getLikesBySession,
  followAnArtist,
  getFollowsByArtist,
  totalFollowsByArtist,
};
